export default __webpack_public_path__ + "static/pr-add-devices-7bb0951132c298a0c4a59288660ff742.png";